/* eslint-disable vue/no-side-effects-in-computed-properties */
<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/home">
      <CIcon
        class="d-block"
        name="logo"
        size="custom-size"
        :height="40"
        :viewBox="`${minimize ? 390 : 0} 0 ${minimize ? 176 : 576} 74`"
      />
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="computedNav" />
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import nav from "./_nav";

export default {
  name: "TheSidebar",
  data() {
    return {
      nav_filtered: null,
      nav: nav,
      nav_save: nav,
      nav_saved: null,
      tipo: "",
    };
  },
  mounted() {
    this.tipo = this.getTipo;
  },
  created() {
    this.tipo = this.getTipo;
  },

  computed: {
    computedNav: function () {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.nav = {
        items: [
          {
            _name: "CSidebarNav",
            _children: [
              {
                _name: "CSidebarNavDropdown",
                name: "Controle de entregas",
                route: "/controle",

                icon: "cil-chart-line",
                meta: { roles: "AD | SA" },

                items: [
                  {
                    name: "Mapa",
                    to: "/controle/mapa_entregadores",
                  },
                  {
                    name: "Detalhes",
                    to: "/controle/solicitacao_detalhes",
                  },
                  {
                    name: "Abrir solicitação",
                    to: "/controle/solicitacao_admin",
                  },
                ],
              },
              {
                _name: "CSidebarNavDropdown",
                name: "Controle de entregas",
                route: "/controle",

                icon: "cil-chart-line",
                meta: { roles: "SP|SF" },

                items: [
                  {
                    name: "Abrir solicitação",
                    to: "/controle/solicitacao_admin",
                  },
                  {
                    name: "Detalhes",
                    to: "/controle/solicitacao_detalhes",
                  },
                ],
              },
              {
                _name: "CSidebarNavDropdown",
                name: "Entregas",
                route: "/entregas",
                icon: "cil-bike",
                meta: { roles: "SP|SF" },

                items: [
                  {
                    name: "Histórico",
                    to: "/entregas/historico",
                  },
                ],
              },

              {
                _name: "CSidebarNavDropdown",
                name: "Solicitar",
                route: "/solicitar_funcionario",
                icon: "cil-bell",
                meta: { roles: "FU" },
                items: [
                  {
                    name: "Nova solicitação",
                    to: "/solicitar/solicitacoes_funcionario",
                  },
                ],
              },
              {
                _name: "CSidebarNavDropdown",
                name: "Solicitar",
                route: "/solicitar",
                icon: "cil-bell",
                meta: { roles: "CO" },
                items: [
                  {
                    name: "Nova solicitação",
                    to: "/solicitar/solicitacoes",
                  },
                ],
              },
              {
                _name: "CSidebarNavDropdown",
                name: "Entregas",
                route: "/entregas",
                icon: "cil-bike",
                meta: { roles: "CO" },

                items: [
                  {
                    name: "Histórico",
                    to: "/entregas/historico",
                  },
                ],
              },
              {
                _name: "CSidebarNavDropdown",
                name: "Entregas",
                route: "/entregas",
                icon: "cil-bike",
                meta: { roles: "FU" },

                items: [
                  {
                    name: "Histórico",
                    to: "/entregas/historico_funcionario",
                  },
                ],
              },
              {
                _name: "CSidebarNavDropdown",
                name: "Entregas",
                route: "/entregas",
                icon: "cil-bike",
                meta: { roles: "PE | MT" },

                items: [
                  {
                    name: "Histórico",
                    to: "/entregas/historico",
                  },
                  {
                    name: "Cadastrar Entrega",
                    to: "/entregas/cadastro_entrega",
                  },
                  {
                    name: "Cadastrar distribuição",
                    to: "/entregas/cadastro_distribuicao",
                  },
                ],
              },
              {
                _name: "CSidebarNavDropdown",
                name: "Entregas",
                route: "/entregas",
                icon: "cil-bike",
                meta: { roles: "AD | SA" },

                items: [
                  {
                    name: "Histórico",
                    to: "/entregas/historico",
                  },
                  {
                    name: "Cadastrar Entrega",
                    to: "/entregas/cadastro_entrega",
                  },
                  {
                    name: "Cadastrar distribuição",
                    to: "/entregas/cadastro_distribuicao",
                  },
                  {
                    name: "Entregadores fixos",
                    to: "/entregas/fixo",
                  },
                  {
                    name: "Editar entregas",
                    to: "/entregas/editar_varias",
                  },
                  {
                    name: "Porcentagem chuva",
                    to: "/entregas/porcentagem_chuva",
                  },
                  {
                    name: "Porcentagem cadastro",
                    to: "/entregas/porcentagem_cadastro",
                  },
                ],
              },
              // {
              //   _name: 'CSidebarNavDropdown',
              //   name: 'Entregas',
              //   icon: 'cil-bike',
              //   meta: { roles: "CO" },

              //   items: [
              //     {
              //       name: 'Histórico',
              //       to: '/Entregas'
              //     }
              //   ]
              // },
              {
                _name: "CSidebarNavDropdown",
                name: "Financeiro",
                icon: "cil-balance-scale",
                route: "/financeiro",
                meta: { roles: "AD | SA" },

                items: [
                  {
                    name: "Caixa",
                    to: "/financeiro/caixa",
                    meta: {
                      roles: "AD|SA",
                    },
                  },
                  {
                    name: "Fazer acerto",
                    to: "/financeiro/acerto",
                    meta: {
                      roles: "AD|SA",
                    },
                  },
                  {
                    name: "Devolução pendente",
                    to: "/financeiro/devolucao",
                    meta: {
                      roles: "AD|SA",
                    },
                  },
                  {
                    name: "Relatório de entregas",
                    to: "/financeiro/relatorio_entregas",
                    meta: {
                      roles: "AD|SA",
                    },
                  },
                  // {
                  //   name: "Pagamento parceiros",
                  //   to: "/financeiro/pagamento_parceiros",
                  // },
                  {
                    name: "Configurações",
                    to: "/financeiro/configuracoes",
                    meta: {
                      roles: "AD|SA",
                    },
                  },
                ],
              },
              {
                _name: "CSidebarNavDropdown",
                name: "Financeiro",
                icon: "cil-balance-scale",
                route: "/financeiro",
                meta: { roles: "SF" },

                items: [
                  {
                    name: "Fazer acerto",
                    to: "/financeiro/acerto",
                    meta: {
                      roles: "SF",
                    },
                  },
                  {
                    name: "Devolução pendente",
                    to: "/financeiro/devolucao",
                    meta: {
                      roles: "SF",
                    },
                  },
                ],
              },
              {
                _name: "CSidebarNavDropdown",
                name: "Financeiro",
                route: "/financeiro",
                icon: "cil-balance-scale",
                meta: { roles: "PE | MT" },

                items: [
                  {
                    name: "Saldo e extrato",
                    to: "/financeiro/saldo",
                  },
                ],
              },
              {
                _name: "CSidebarNavDropdown",
                name: "Financeiro",
                route: "/financeiro",
                icon: "cil-balance-scale",
                meta: { roles: "CO" },

                items: [
                  {
                    name: "Saldo e extrato",
                    to: "/financeiro/saldo",
                  },
                  {
                    name: "Relatório entregas",
                    to: "/financeiro/relatorio_entregas_parceiro",
                  },
                ],
              },

              {
                _name: "CSidebarNavItem",
                name: "Contestações",
                route: "/contestacoes",
                to: "/contestacoes",
                icon: "cil-warning",
                meta: { roles: "AD | SA | SF" },
              },
              {
                _name: "CSidebarNavDropdown",
                name: "Agendamento",
                icon: "cil-calendar",
                meta: { roles: "SA" },

                items: [
                  {
                    name: "Agendamento bikers",
                    to: "/agendamento",
                  },
                  {
                    name: "Agendamento motoboys",
                    to: "/AgendamentoMotoboy",
                  },
                  {
                    name: "Configurações",
                    to: "/ConfiguracoesAgen",
                  },
                ],
              },
              // {
              //   _name: 'CSidebarNavDropdown',
              //   name: 'Configurações agendamento',
              //   icon: 'cil-settings',
              //   meta: { roles: "SA" },

              //   items: [
              //     {
              //       name: 'Editar turnos',
              //       to: '/turnos'
              //     },
              //     {
              //       name: 'Editar dias da semana',
              //       to: '/dias_semana'
              //     },
              //     {
              //       name: 'Editar status agendamento',
              //       to: '/status_agendamento'
              //     }

              //   ]
              // },
              {
                _name: "CSidebarNavDropdown",
                name: "Usuários",
                icon: "cil-user",
                route: "/usuarios",
                meta: { roles: "SP|SF" },
                items: [
                  {
                    name: "Bikers",
                    to: "/usuarios/bikers",
                  },
                  {
                    name: "Motoboys",
                    to: "/usuarios/motoboys",
                  },
                  {
                    name: "Parceiros",
                    to: "/usuarios/parceiros",
                  },
                ],
              },
              {
                _name: "CSidebarNavItem",
                name: "Tabela de Preços",
                route: "/tabela_bairros",
                to: "/tabela_bairros",
                icon: "cil-clipboard",
                meta: { roles: "CO" },
              },
              {
                _name: "CSidebarNavItem",
                name: "Funcionários",
                route: "/funcionarios",
                to: "/funcionarios",
                icon: "cil-people",
                meta: { roles: "CO" },
              },
              {
                _name: "CSidebarNavDropdown",
                name: "Tabelas de preços",
                route: "/tabelas_preco",
                icon: "cil-clipboard",
                meta: { roles: "AD | SA" },
                items: [
                  {
                    name: "Distribuição",
                    to: "/tabelas_preco/tabela_distribuicao",
                  },
                  {
                    name: "Entrega simples",
                    to: "/tabelas_preco/tabela",
                  },

                  {
                    name: "Tabelas padrão",
                    to: "/tabelas_preco/tabela_padrao",
                  },
                ],
              },
              {
                _name: "CSidebarNavItem",
                name: "Lista ruas",
                route: "/lista_ruas",
                to: "/lista_ruas",
                icon: "cil-folder",
                meta: { roles: "SP | SF" },
              },
              {
                _name: "CSidebarNavDropdown",
                name: "Editar ruas e bairros",
                icon: "cil-folder",
                route: "/edita_rua_bairro",
                meta: { roles: "AD | SA" },
                items: [
                  {
                    name: "Editar bairros",
                    to: "/edita_rua_bairro/edita_bairro",
                  },
                  {
                    name: "Editar ruas",
                    to: "/edita_rua_bairro/edita_ruas",
                  },
                  {
                    name: "Bairros sem tabela",
                    to: "/edita_rua_bairro/bairro_sem_tabela",
                  },
                  {
                    name: "Editar regras",
                    to: "/edita_rua_bairro/editar_regras",
                  },
                  {
                    name: "Ruas padrão",
                    to: "/edita_rua_bairro/ruas_padrao",
                  },
                  {
                    name: "Tabela ruas parceiro",
                    to: "/edita_rua_bairro/tabela_rua_parceiro",
                  },
                ],
              },
              {
                _name: "CSidebarNavDropdown",
                name: "Usuários",
                icon: "cil-user",
                route: "/usuarios",
                meta: { roles: "AD | SA" },
                items: [
                  {
                    name: "Todos",
                    to: "/usuarios/todos",
                  },
                  {
                    name: "Bikers",
                    to: "/usuarios/bikers",
                  },
                  {
                    name: "Motoboys",
                    to: "/usuarios/motoboys",
                  },
                  {
                    name: "Parceiros",
                    to: "/usuarios/parceiros",
                  },
                  {
                    name: "Admins",
                    to: "/usuarios/admins",
                  },
                  {
                    name: "Suporte",
                    to: "/usuarios/suporte",
                  },
                ],
              },
              {
                _name: "CSidebarNavDropdown",
                name: "Termos e regras",
                route: "/termos",

                icon: "cil-description",
                meta: { roles: "AD | SA" },
                items: [
                  {
                    name: "Termos de uso",
                    to: "/termos/termos_uso",
                  },
                  // {
                  //   name: 'Regras',
                  //   to: '/termos/regras'
                  // },
                  {
                    name: "Clube de vantagens",
                    to: "/termos/vantagens",
                  },
                  {
                    name: "Upload arquivos",
                    to: "/termos/upload_arquivo",
                  },
                ],
              },
              {
                _name: "CSidebarNavDropdown",
                name: "Termos e regras",
                icon: "cil-description",
                route: "/termos",

                meta: { roles: "PE | MT" },
                items: [
                  {
                    name: "Termos de uso",
                    to: "/termos/termos_uso",
                  },
                  // {
                  //   name: 'Regras',
                  //   to: '/termos/regras'
                  // },
                  {
                    name: "Clube de vantagens",
                    to: "/termos/vantagens",
                  },
                ],
              },
              {
                _name: "CSidebarNavDropdown",
                name: "Configurações",
                route: "/configuracoes_funcionario",

                icon: "cil-settings",
                meta: { roles: "FU" },
                items: [
                  {
                    name: "Dados pessoais",
                    to: "/configuracoes/informacoes_pessoas_funcionario",
                  },
                ],
              },
              {
                _name: "CSidebarNavDropdown",
                name: "Configurações",
                route: "/configuracoes",

                icon: "cil-settings",
                meta: { roles: "AD | SA | CO" },
                items: [
                  {
                    name: "Dados pessoais",
                    to: "/configuracoes/informacoes_pessoas",
                  },
                  {
                    name: "Endereço",
                    to: "/configuracoes/endereco",
                  },
                ],
              },
              {
                _name: "CSidebarNavDropdown",
                name: "Configurações",
                route: "/configuracoes",

                icon: "cil-settings",
                meta: { roles: "SP|SF" },
                items: [
                  {
                    name: "Dados pessoais",
                    to: "/configuracoes/informacoes_pessoas",
                  },
                ],
              },

              {
                _name: "CSidebarNavDropdown",
                name: "Configurações",
                route: "/configuracoes",

                icon: "cil-settings",
                meta: { roles: "PE | MT" },
                items: [
                  {
                    name: "Dados pessoais",
                    to: "/configuracoes/informacoes_pessoas",
                  },
                ],
              },
            ],
          },
        ],
      };
      // console.log(this.nav.items[0]._children);
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      // this.nav = this.nav_save;
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.nav_filtered = this.nav.items[0]._children.filter((item) =>
        item.meta.roles.includes(this.getTipo)
      );

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.nav_save.items[0]._children = this.nav_filtered;
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.nav_saved = this.nav_save.items;
      this.$forceUpdate();

      return this.nav_saved;
    },
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
    getTipo() {
      return this.$store.getters.getTipo;
    },
  },
  methods: {},
};
</script>
